import { TemporaryOrganisationRoleResponse } from '../../api-models/types.gen';
import { ViewAsResponse } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostViewAsOrganisation extends BaseAdapter<TemporaryOrganisationRoleResponse> implements AdapterInterface {
  rawResponse: TemporaryOrganisationRoleResponse;

  async adaptResponse(data: { organisation: string }): Promise<ViewAsResponse> {
    await this.fetchApiResponse('/api/view-as-organisation', HTTPMethod.Post, { display_name: data.organisation });
    return {
      temporaryOrganisationName: this.rawResponse.temporary_organisation_name,
      temporaryRoleName: this.rawResponse.temporary_role_name,
    };
  }
}
